<template>
  <div class="pt-6">
    <v-container>
      <v-form ref="tableForm" v-model="tForm" lazy-validation v-if="!tabletFlg">
        <v-card max-width="1900">
          <v-container>
            <!-- 月次確定未確定 -->
            <v-row>
              <v-col cols="3"></v-col>
              <v-col
                class="row_style"
                cols="1"
                v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
                :key="index"
              >
                <label v-if="claimInfoDetail.month_close_flg">確定情報</label>
                <label v-else style="color: red">月次未確定</label>
              </v-col>
            </v-row>
            <!-- 請求月 -->
            <v-row>
              <v-col cols="3"></v-col>
              <v-col
                class="row_style"
                cols="1"
                align="center"
                v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
                :key="index"
              >
                <label
                  >{{ claimInfoDetail.billing_month }}<br />({{
                    getArchiveDataRange(claimInfoDetail.billing_month)
                  }})</label
                >
              </v-col>
            </v-row>
            <!-- 部屋代 -->
            <v-row v-if="dmsUseFlg">
              <v-col
                class="row_style_top"
                style="background-color: #64b5f6"
                cols="2"
              >
                <label>部屋代</label>
              </v-col>
              <v-col class="row_style" cols="1">
                <label>{{ this.room_class_name }}</label>
              </v-col>
              <v-col
                class="row_style"
                cols="1"
                align="right"
                v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
                :key="index"
              >
                <label
                  >{{
                    Number(claimInfoDetail.room_fee).toLocaleString()
                  }}円</label
                >
              </v-col>
            </v-row>
            <v-row v-if="dmsUseFlg">
              <v-col
                class="row_style_bottom"
                style="background-color: #64b5f6"
                cols="2"
              ></v-col>
              <v-col
                class="row_style"
                style="background-color: #64b5f6"
                cols="1"
              >
                <label>小計</label>
              </v-col>
              <v-col
                class="row_style"
                style="background-color: #64b5f6"
                cols="1"
                align="right"
                v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
                :key="index"
              >
                <label
                  >{{
                    Number(claimInfoDetail.room_fee).toLocaleString()
                  }}円</label
                >
              </v-col>
            </v-row>
            <!-- 食事代 -->
            <v-row
              v-if="mealUseFlg"
              v-for="(meal_item, list_index) in this.meal_list"
              :key="`meal_list_${list_index}`"
            >
              <v-col
                class="row_style_top"
                style="background-color: #64b5f6"
                cols="2"
                v-if="list_index == 0"
                >食事代</v-col
              >
              <v-col
                class="row_style_center"
                style="background-color: #64b5f6"
                cols="2"
                v-if="list_index != 0"
              ></v-col>
              <v-col class="row_style" cols="1">
                <label>{{ meal_item[0].class_name }}</label>
              </v-col>
              <v-col
                class="row_style"
                cols="1"
                align="right"
                v-for="(item, index) in meal_item"
                :key="index"
              >
                <label v-if="list_index != 0">{{ item.num }}食</label>
                <label>{{ Number(item.fee).toLocaleString() }}円</label>
              </v-col>
            </v-row>
            <!-- 食事代小計 -->
            <v-row v-if="mealUseFlg">
              <v-col
                class="row_style_bottom"
                style="background-color: #64b5f6"
                cols="2"
              ></v-col>
              <v-col
                class="row_style"
                style="background-color: #64b5f6"
                cols="1"
              >
                <label>小計</label>
              </v-col>
              <v-col
                class="row_style"
                style="background-color: #64b5f6"
                cols="1"
                align="right"
                v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
                :key="index"
              >
                <label
                  >{{
                    Number(claimInfoDetail.meal_amount).toLocaleString()
                  }}円</label
                >
              </v-col>
            </v-row>
            <!-- 車両代 -->
            <v-row
              v-if="carUseFlg"
              v-for="(vehicle_item, list_index) in this.vehicle_list"
              :key="`vehicle_list_${list_index}`"
            >
              <v-col
                class="row_style_top"
                style="background-color: #64b5f6"
                cols="2"
                v-if="list_index == 0"
                >車両代</v-col
              >
              <v-col
                class="row_style_center"
                style="background-color: #64b5f6"
                cols="2"
                v-if="list_index != 0"
              ></v-col>
              <v-col class="row_style" cols="1">
                <label>{{ vehicle_item[0].class_name }}</label>
              </v-col>
              <v-col
                class="row_style"
                cols="1"
                align="right"
                v-for="(item, index) in vehicle_item"
                :key="index"
              >
                <label>{{ item.num }}台</label>
                <label>{{ Number(item.fee).toLocaleString() }}円</label>
              </v-col>
            </v-row>
            <!-- 車代小計 -->
            <v-row v-if="carUseFlg">
              <v-col
                class="row_style_bottom"
                style="background-color: #64b5f6"
                cols="2"
              ></v-col>
              <v-col
                class="row_style"
                style="background-color: #64b5f6"
                cols="1"
              >
                <label>小計</label>
              </v-col>
              <v-col
                class="row_style"
                style="background-color: #64b5f6"
                cols="1"
                align="right"
                v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
                :key="index"
              >
                <label
                  >{{
                    Number(claimInfoDetail.vehicle_amount).toLocaleString()
                  }}円</label
                >
              </v-col>
            </v-row>
            <!-- 電気代 -->
            <v-row v-if="elUseFlg">
              <v-col
                class="row_style_top"
                style="background-color: #64b5f6"
                cols="2"
              >
                <label>電気代</label>
              </v-col>
              <v-col class="row_style" cols="1">
                <label>利用量</label>
              </v-col>
              <v-col
                class="row_style"
                cols="1"
                align="right"
                v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
                :key="index"
              >
                <label
                  >{{
                    Number(
                      claimInfoDetail.electrical_use_amount
                    ).toLocaleString()
                  }}kw</label
                >
              </v-col>
            </v-row>
            <!-- 電気代小計 -->
            <v-row v-if="elUseFlg">
              <v-col
                class="row_style_bottom"
                style="background-color: #64b5f6"
                cols="2"
              ></v-col>
              <v-col
                class="row_style"
                style="background-color: #64b5f6"
                cols="1"
              >
                <label>料金</label>
              </v-col>
              <v-col
                class="row_style"
                style="background-color: #64b5f6"
                cols="1"
                align="right"
                v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
                :key="index"
              >
                <label
                  >{{
                    Number(claimInfoDetail.electrical_use_fee).toLocaleString()
                  }}円</label
                >
              </v-col>
            </v-row>
            <!-- ガス代 -->
            <v-row v-if="gasUseFlg">
              <v-col
                class="row_style_top"
                style="background-color: #64b5f6"
                cols="2"
              >
                <label>ガス代</label>
              </v-col>
              <v-col class="row_style" cols="1">
                <label>利用量</label>
              </v-col>
              <v-col
                class="row_style"
                cols="1"
                align="right"
                v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
                :key="index"
              >
                <label
                  >{{
                    Number(claimInfoDetail.gas_use_amount).toLocaleString()
                  }}m³</label
                >
              </v-col>
            </v-row>
            <!-- ガス代小計 -->
            <v-row v-if="gasUseFlg">
              <v-col
                class="row_style_bottom"
                style="background-color: #64b5f6"
                cols="2"
              ></v-col>
              <v-col
                class="row_style"
                style="background-color: #64b5f6"
                cols="1"
              >
                <label>料金</label>
              </v-col>
              <v-col
                class="row_style"
                style="background-color: #64b5f6"
                cols="1"
                align="right"
                v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
                :key="index"
              >
                <label
                  >{{
                    Number(claimInfoDetail.gas_use_fee).toLocaleString()
                  }}円</label
                >
              </v-col>
            </v-row>
            <!-- 水道代 -->
            <v-row v-if="waUseFlg">
              <v-col
                class="row_style_top"
                style="background-color: #64b5f6"
                cols="2"
              >
                <label>水道代</label>
              </v-col>
              <v-col class="row_style" cols="1">
                <label>利用量</label>
              </v-col>
              <v-col
                class="row_style"
                cols="1"
                align="right"
                v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
                :key="index"
              >
                <label
                  >{{
                    Number(claimInfoDetail.water_use_amount).toLocaleString()
                  }}m³</label
                >
              </v-col>
            </v-row>
            <!-- 水道代小計 -->
            <v-row v-if="waUseFlg">
              <v-col
                class="row_style_bottom"
                style="background-color: #64b5f6"
                cols="2"
              ></v-col>
              <v-col
                class="row_style"
                style="background-color: #64b5f6"
                cols="1"
              >
                <label>料金</label>
              </v-col>
              <v-col
                class="row_style"
                style="background-color: #64b5f6"
                cols="1"
                align="right"
                v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
                :key="index"
              >
                <label
                  >{{
                    Number(claimInfoDetail.water_use_fee).toLocaleString()
                  }}円</label
                >
              </v-col>
            </v-row>
            <!-- コミュニケーションルーム -->
            <v-row v-if="nskimitsuDisp">
              <v-col
                class="row_style_top"
                style="background-color: #64b5f6"
                cols="2"
              >
                <label>コミュニケーションルーム</label>
              </v-col>
              <v-col class="row_style" cols="1">
                <label>飲食代</label>
              </v-col>
              <v-col
                class="row_style"
                cols="1"
                align="right"
                v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
                :key="index"
              >
                <label
                  >{{
                    Number(claimInfoDetail.cr_fee).toLocaleString()
                  }}円</label
                >
              </v-col>
            </v-row>
            <v-row v-if="nskimitsuDisp">
              <v-col
                class="row_style_bottom"
                style="background-color: #64b5f6"
                cols="2"
              ></v-col>
              <v-col
                class="row_style"
                style="background-color: #64b5f6"
                cols="1"
              >
                <label>小計</label>
              </v-col>
              <v-col
                class="row_style"
                style="background-color: #64b5f6"
                cols="1"
                align="right"
                v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
                :key="index"
              >
                <label
                  >{{
                    Number(claimInfoDetail.cr_fee).toLocaleString()
                  }}円</label
                >
              </v-col>
            </v-row>
            <!-- 自治会費 -->
            <v-row v-if="neiUseFlg">
              <v-col
                class="row_style_top"
                style="background-color: #64b5f6"
                cols="2"
              >
                <label>自治会費</label>
              </v-col>
              <v-col class="row_style" cols="1">
                <label>基本会費</label>
              </v-col>
              <v-col
                class="row_style"
                cols="1"
                align="right"
                v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
                :key="index"
              >
                <label
                  >{{
                    Number(
                      claimInfoDetail.resident_association_cost
                    ).toLocaleString()
                  }}円</label
                >
              </v-col>
            </v-row>
            <v-row v-if="neiUseFlg">
              <v-col
                class="row_style_center"
                style="background-color: #64b5f6"
                cols="2"
              ></v-col>
              <v-col class="row_style" cols="1">
                <label>免除</label>
              </v-col>
              <v-col
                class="row_style"
                cols="1"
                align="right"
                v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
                :key="index"
              >
                <label
                  >{{
                    Number(
                      claimInfoDetail.resident_association_exe_cost
                    ).toLocaleString()
                  }}円</label
                >
              </v-col>
            </v-row>
            <v-row v-if="neiUseFlg">
              <v-col
                class="row_style_bottom"
                style="background-color: #64b5f6"
                cols="2"
              ></v-col>
              <v-col
                class="row_style"
                style="background-color: #64b5f6"
                cols="1"
              >
                <label>小計</label>
              </v-col>
              <v-col
                class="row_style"
                style="background-color: #64b5f6"
                cols="1"
                align="right"
                v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
                :key="index"
              >
                <label
                  >{{
                    Number(
                      claimInfoDetail.resident_association_cost_subtotal
                    ).toLocaleString()
                  }}円</label
                >
              </v-col>
            </v-row>
            <!-- その他課金 -->
            <!-- その他課金詳細（その他課金マスタにあるもの） -->
            <v-row
              v-if="ocUseFlg"
              v-for="(other_master_item, list_index) in this.other_master_list"
              :key="`other_master_list_${list_index}`"
            >
              <v-col
                class="row_style_top"
                style="background-color: #64b5f6"
                cols="2"
                v-if="list_index == 0"
                >その他</v-col
              >
              <v-col
                class="row_style_center"
                style="background-color: #64b5f6"
                cols="2"
                v-if="list_index != 0"
              ></v-col>
              <v-col class="row_style" cols="1">
                <label>{{ other_master_item[0].class_name }}</label>
              </v-col>
              <v-col
                class="row_style"
                cols="1"
                align="right"
                v-for="(item, index) in other_master_item"
                :key="index"
              >
                <label>{{ item.num }}回</label>
                <label>{{ Number(item.fee).toLocaleString() }}円</label>
              </v-col>
            </v-row>
            <!-- その他課金詳細残り（その他課金マスタにないもの） -->
            <v-row
              v-if="ocUseFlg"
              v-for="(other_item, list_index) in this.other_list"
              :key="`other_list_${list_index}`"
            >
              <v-col
                class="row_style_center"
                style="background-color: #64b5f6"
                cols="2"
              ></v-col>
              <v-col class="row_style" cols="1">その他</v-col>
              <v-col
                class="row_style"
                cols="1"
                align="right"
                v-for="(item, index) in other_item"
                :key="index"
              >
                <label v-if="item.class_name != ''">{{
                  item.class_name
                }}</label>
                <label v-if="item.class_name != ''"
                  >{{ Number(item.fee).toLocaleString() }}円</label
                >
              </v-col>
            </v-row>
            <v-row v-if="ocUseFlg">
              <v-col
                class="row_style_bottom"
                style="background-color: #64b5f6"
                cols="2"
              ></v-col>
              <v-col
                class="row_style"
                style="background-color: #64b5f6"
                cols="1"
              >
                <label>小計</label>
              </v-col>
              <v-col
                class="row_style"
                style="background-color: #64b5f6"
                cols="1"
                align="right"
                v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
                :key="index"
              >
                <label
                  >{{
                    Number(claimInfoDetail.other_amount).toLocaleString()
                  }}円</label
                >
              </v-col>
            </v-row>
            <!-- 合計 -->
            <v-row>
              <v-col
                class="row_style"
                style="background-color: #64b5f6"
                cols="2"
              >
                <label>合計</label>
              </v-col>
              <v-col
                class="row_style"
                style="background-color: #64b5f6"
                cols="1"
              >
                <label></label>
              </v-col>
              <v-col
                class="row_style"
                style="background-color: #64b5f6"
                cols="1"
                align="right"
                v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
                :key="index"
              >
                <label
                  >{{
                    Number(claimInfoDetail.total_fee).toLocaleString()
                  }}円</label
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-form>
      <v-form ref="tableForm" v-model="tForm" lazy-validation v-if="tabletFlg">
        <!-- 部屋代 -->
        <v-row v-if="dmsUseFlg">
          <v-col
            class="row_style_bottom"
            style="background-color: #64b5f6"
            cols="7"
          >
            <label>部屋代</label>
          </v-col>
          <v-col
            class="row_style"
            style="background-color: #64b5f6"
            cols="5"
            align="right"
            v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
            :key="index"
          >
            <label
              >{{ Number(claimInfoDetail.room_fee).toLocaleString() }}円</label
            >
          </v-col>
        </v-row>
        <!-- 食事代 -->
        <v-row
          v-if="mealUseFlg"
          v-for="(meal_item, list_index) in this.meal_list"
          :key="`meal_list_${list_index}`"
        >
          <v-col
            class="row_style_top"
            style="background-color: #64b5f6"
            cols="3"
            v-if="list_index == 0"
            >食事代</v-col
          >
          <v-col
            class="row_style_center"
            style="background-color: #64b5f6"
            cols="3"
            v-if="list_index != 0"
          ></v-col>
          <v-col class="row_style" cols="4">
            <label>{{ meal_item[0].class_name }}</label>
          </v-col>
          <v-col
            class="row_style"
            cols="5"
            align="right"
            v-for="(item, index) in meal_item"
            :key="index"
          >
            <label v-if="list_index != 0">{{ item.num }}食</label>
            <label>{{ Number(item.fee).toLocaleString() }}円</label>
          </v-col>
        </v-row>
        <!-- 食事代小計 -->
        <v-row v-if="mealUseFlg">
          <v-col
            class="row_style_bottom"
            style="background-color: #64b5f6"
            cols="3"
          ></v-col>
          <v-col class="row_style" style="background-color: #64b5f6" cols="4">
            <label>小計</label>
          </v-col>
          <v-col
            class="row_style"
            style="background-color: #64b5f6"
            cols="5"
            align="right"
            v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
            :key="index"
          >
            <label
              >{{
                Number(claimInfoDetail.meal_amount).toLocaleString()
              }}円</label
            >
          </v-col>
        </v-row>
        <!-- 車代小計 -->
        <v-row v-if="carUseFlg">
          <v-col
            class="row_style_bottom"
            style="background-color: #64b5f6"
            cols="7"
          >
            <label>車両代</label>
          </v-col>
          <v-col
            class="row_style"
            style="background-color: #64b5f6"
            cols="5"
            align="right"
            v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
            :key="index"
          >
            <label
              >{{
                Number(claimInfoDetail.vehicle_amount).toLocaleString()
              }}円</label
            >
          </v-col>
        </v-row>
        <!-- 電気代 -->
        <v-row v-if="elUseFlg">
          <v-col
            class="row_style_top"
            style="background-color: #64b5f6"
            cols="4"
          >
            <label>電気代</label>
          </v-col>
          <v-col class="row_style" cols="3">
            <label>利用量</label>
          </v-col>
          <v-col
            class="row_style"
            cols="5"
            align="right"
            v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
            :key="index"
          >
            <label
              >{{
                Number(claimInfoDetail.electrical_use_amount).toLocaleString()
              }}kw</label
            >
          </v-col>
        </v-row>
        <!-- 電気代小計 -->
        <v-row v-if="elUseFlg">
          <v-col
            class="row_style_bottom"
            style="background-color: #64b5f6"
            cols="4"
          ></v-col>
          <v-col class="row_style" style="background-color: #64b5f6" cols="3">
            <label>料金</label>
          </v-col>
          <v-col
            class="row_style"
            style="background-color: #64b5f6"
            cols="5"
            align="right"
            v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
            :key="index"
          >
            <label
              >{{
                Number(claimInfoDetail.electrical_use_fee).toLocaleString()
              }}円</label
            >
          </v-col>
        </v-row>
        <!-- ガス代 -->
        <v-row v-if="gasUseFlg">
          <v-col
            class="row_style_top"
            style="background-color: #64b5f6"
            cols="4"
          >
            <label>ガス代</label>
          </v-col>
          <v-col class="row_style" cols="3">
            <label>利用量</label>
          </v-col>
          <v-col
            class="row_style"
            cols="5"
            align="right"
            v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
            :key="index"
          >
            <label
              >{{
                Number(claimInfoDetail.gas_use_amount).toLocaleString()
              }}m³</label
            >
          </v-col>
        </v-row>
        <!-- ガス代小計 -->
        <v-row v-if="gasUseFlg">
          <v-col
            class="row_style_bottom"
            style="background-color: #64b5f6"
            cols="4"
          ></v-col>
          <v-col class="row_style" style="background-color: #64b5f6" cols="3">
            <label>料金</label>
          </v-col>
          <v-col
            class="row_style"
            style="background-color: #64b5f6"
            cols="5"
            align="right"
            v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
            :key="index"
          >
            <label
              >{{
                Number(claimInfoDetail.gas_use_fee).toLocaleString()
              }}円</label
            >
          </v-col>
        </v-row>
        <!-- 水道代 -->
        <v-row v-if="waUseFlg">
          <v-col
            class="row_style_top"
            style="background-color: #64b5f6"
            cols="4"
          >
            <label>水道代</label>
          </v-col>
          <v-col class="row_style" cols="3">
            <label>利用量</label>
          </v-col>
          <v-col
            class="row_style"
            cols="5"
            align="right"
            v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
            :key="index"
          >
            <label
              >{{
                Number(claimInfoDetail.water_use_amount).toLocaleString()
              }}m³</label
            >
          </v-col>
        </v-row>
        <!-- 水道代小計 -->
        <v-row v-if="waUseFlg">
          <v-col
            class="row_style_bottom"
            style="background-color: #64b5f6"
            cols="4"
          ></v-col>
          <v-col class="row_style" style="background-color: #64b5f6" cols="3">
            <label>料金</label>
          </v-col>
          <v-col
            class="row_style"
            style="background-color: #64b5f6"
            cols="5"
            align="right"
            v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
            :key="index"
          >
            <label
              >{{
                Number(claimInfoDetail.water_use_fee).toLocaleString()
              }}円</label
            >
          </v-col>
        </v-row>
        <!-- コミュニケーションルーム -->
        <v-row v-if="nskimitsuDisp">
          <v-col
            class="row_style_bottom"
            style="background-color: #64b5f6"
            cols="7"
          >
            <label>ｺﾆｭﾆｹｰｼｮﾝﾙｰﾑ</label>
          </v-col>
          <v-col
            class="row_style"
            style="background-color: #64b5f6"
            cols="5"
            align="right"
            v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
            :key="index"
          >
            <label
              >{{ Number(claimInfoDetail.cr_fee).toLocaleString() }}円</label
            >
          </v-col>
        </v-row>
        <!-- 自治会費 -->
        <v-row v-if="neiUseFlg">
          <v-col
            class="row_style_top"
            style="background-color: #64b5f6"
            cols="3"
          >
            <label>自治会費</label>
          </v-col>
          <v-col class="row_style" cols="4">
            <label>基本会費</label>
          </v-col>
          <v-col
            class="row_style"
            cols="5"
            align="right"
            v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
            :key="index"
          >
            <label
              >{{
                Number(
                  claimInfoDetail.resident_association_cost
                ).toLocaleString()
              }}円</label
            >
          </v-col>
        </v-row>
        <v-row v-if="neiUseFlg">
          <v-col
            class="row_style_center"
            style="background-color: #64b5f6"
            cols="3"
          ></v-col>
          <v-col class="row_style" cols="4">
            <label>免除</label>
          </v-col>
          <v-col
            class="row_style"
            cols="5"
            align="right"
            v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
            :key="index"
          >
            <label
              >{{
                Number(
                  claimInfoDetail.resident_association_exe_cost
                ).toLocaleString()
              }}円</label
            >
          </v-col>
        </v-row>
        <v-row v-if="neiUseFlg">
          <v-col
            class="row_style_bottom"
            style="background-color: #64b5f6"
            cols="3"
          ></v-col>
          <v-col class="row_style" style="background-color: #64b5f6" cols="4">
            <label>小計</label>
          </v-col>
          <v-col
            class="row_style"
            style="background-color: #64b5f6"
            cols="5"
            align="right"
            v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
            :key="index"
          >
            <label
              >{{
                Number(
                  claimInfoDetail.resident_association_cost_subtotal
                ).toLocaleString()
              }}円</label
            >
          </v-col>
        </v-row>
        <!-- その他課金 -->
        <!-- その他課金詳細（その他課金マスタにあるもの） -->
        <v-row
          v-if="ocUseFlg"
          v-for="(other_master_item, list_index) in this.other_master_list"
          :key="`other_master_list_${list_index}`"
        >
          <v-col
            class="row_style_top"
            style="background-color: #64b5f6"
            cols="3"
            v-if="list_index == 0"
            >その他</v-col
          >
          <v-col
            class="row_style_center"
            style="background-color: #64b5f6"
            cols="3"
            v-if="list_index != 0"
          ></v-col>
          <v-col class="row_style" cols="4">
            <label>{{ other_master_item[0].class_name }}</label>
          </v-col>
          <v-col
            class="row_style"
            cols="5"
            align="right"
            v-for="(item, index) in other_master_item"
            :key="index"
          >
            <label v-if="list_index != 0">{{ item.num }}回</label>
            <label>{{ Number(item.fee).toLocaleString() }}円</label>
          </v-col>
        </v-row>
        <!-- その他課金詳細残り（その他課金マスタにないもの） -->
        <v-row
          v-if="ocUseFlg"
          v-for="(other_item, list_index) in this.other_list"
          :key="`other_list_${list_index}`"
        >
          <v-col
            class="row_style_center"
            style="background-color: #64b5f6"
            cols="3"
          ></v-col>
          <v-col class="row_style" cols="4">その他</v-col>
          <v-col
            class="row_style"
            cols="5"
            align="right"
            v-for="(item, index) in other_item"
            :key="index"
          >
            <label v-if="item.class_name != ''">{{ item.class_name }}</label>
            <label v-if="item.class_name != ''"
              >{{ Number(item.fee).toLocaleString() }}円</label
            >
          </v-col>
        </v-row>
        <!-- その他小計 -->
        <v-row v-if="ocUseFlg">
          <v-col
            class="row_style_bottom"
            style="background-color: #64b5f6"
            cols="3"
          ></v-col>
          <v-col class="row_style" style="background-color: #64b5f6" cols="4">
            <label>小計</label>
          </v-col>
          <v-col
            class="row_style"
            style="background-color: #64b5f6"
            cols="5"
            align="right"
            v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
            :key="index"
          >
            <label
              >{{
                Number(claimInfoDetail.other_amount).toLocaleString()
              }}円</label
            >
          </v-col>
        </v-row>
        <!-- 合計 -->
        <v-row>
          <v-col class="row_style" style="background-color: #64b5f6" cols="7">
            <label>合計</label>
          </v-col>
          <v-col
            class="row_style"
            style="background-color: #64b5f6"
            cols="5"
            align="right"
            v-for="(claimInfoDetail, index) in this.claimInfoDetailList"
            :key="index"
          >
            <label
              >{{ Number(claimInfoDetail.total_fee).toLocaleString() }}円</label
            >
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import { RyouTableMixins } from "@/mixins/RyouTableMixins";
export default {
  name: "UserSalaryDeducationIndividual",

  mixins: [RyouTableMixins],
  components: {},
  props: {
    loadFlag: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  watch: {
    selectDate(value) {
      //値が空の場合フィルターをリセットする
      //(値がある場合はダイアログのOKを押下したタイミングでフィルターをセットしている)
      if (!value) {
        this.dateFilterValue = value;
      }
      this.$refs.dateFormatInput.viewDateFlagChange(true);
    },
  },
  data() {
    return {
      tForm: false,
      rowKey: "rowIndex",
      businessKeys: ["user_id", "building_id", "room_id"],
      userName: "",
      userNameKana: "",
      companyName: "",
      userId: "",
      affiliation: "",
      room_class_name: "",
      selectDate: "",
      dateFilterValue: "",
      claimInfoDetailList: [],
      meal_num: 0,
      meal_rowspan: 1,
      meal_list: [],
      vehicle_num: 0,
      vehicle_rowspan: 1,
      vehicle_list: [],
      other_all_num: 0,
      other_master_num: 0,
      other_num: 0,
      other_rowspan: 1,
      other_master_list: [],
      other_list: [],
      height: 578,
      tabletFlg: true,
      nskimitsuDisp: false, // 日鉄物流表示用（それ毎に表示）
      dmsUseFlg: false, //部屋利用フラグ
      carUseFlg: false, //車両利用フラグ
      mealUseFlg: false, //食事利用フラグ
      gasUseFlg: false, //ガス利用フラグ
      elUseFlg: false, //電気利用フラグ
      waUseFlg: false, //水道利用フラグ
      ocUseFlg: false, //その他課金利用フラグ
      neiUseFlg: false, //自治会費利用フラグ
      url: {
        list: "/salaryDeductionInformation/claimInfoDetailGet",
      },
      queryParams: {
        userId: "",
        buildingId: "",
        roomId: "",
        billingMonth: "",
      },
    };
  },
  mounted() {
    if (this.loadFlag) {
      this.fetchIndividualData({ user_id: this.$store.getters.getUserId });
    }
  },
  methods: {
    //DBよりデータを取得
    fetchIndividualData(item) {
      this.queryParams.userId = item.user_id;

      setTimeout(() => {
        let param = {
          multipleMonth: false,
        };
        this.getClaimInfoDetailList(param);
      }, 10);
    },
    // 表示区分セット
    setShowFlg(showFlg) {
      this.tabletFlg = showFlg;
    },
    //画面上部のユーザ情報をセット
    setUserData(item) {
      this.userId = item.user_id;
      this.userName = item.user_name;
      this.userNameKana = item.user_name_kana;
      this.companyName = item.company_name;
      this.affiliation = item.affiliation;

      this.queryParams.buildingId = item.building_id;
      this.queryParams.roomId = item.room_id;
      this.queryParams.billingMonth = item.billing_month;

      this.fetchIndividualData(item);
    },
    prevMonth(item) {
      this.queryParams.billingMonth = item.billing_month;
      let param = {
        multipleMonth: item.multipleMonth,
      };

      this.getClaimInfoDetailList(param);
    },
    nextMonth(item) {
      this.queryParams.billingMonth = item.billing_month;
      let param = {
        multipleMonth: item.multipleMonth,
      };

      this.getClaimInfoDetailList(param);
    },
    history(item) {
      this.queryParams.billingMonth = item.billing_month;
      let param = {
        multipleMonth: item.multipleMonth,
      };

      this.getClaimInfoDetailList(param);
    },
    getClaimInfoDetailList(item) {
      let param = {
        userId: this.queryParams.userId,
        buildingId: this.queryParams.buildingId,
        roomId: this.queryParams.roomId,
        billingMonth: this.queryParams.billingMonth,
        multipleMonth: item.multipleMonth,
      };

      this.getRequest(
        this.url.list,
        param,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          this.claimInfoDetailList = data.result;
          this.meal_num = 0;
          this.vehicle_num = 0;
          this.other_all_num = 0;
          this.other_master_num = 0;
          this.other_num = 0;

          if (this.claimInfoDetailList.length != 0) {
            this.room_class_name = this.claimInfoDetailList[0].room_class_name;
          }

          for (let i = 0; i < this.claimInfoDetailList.length; i++) {
            if (this.meal_num < this.claimInfoDetailList[i].meal_list.length) {
              this.meal_num = this.claimInfoDetailList[i].meal_list.length;
            }

            if (
              this.vehicle_num < this.claimInfoDetailList[i].vehicle_list.length
            ) {
              this.vehicle_num =
                this.claimInfoDetailList[i].vehicle_list.length;
            }

            if (
              this.other_all_num <
              this.claimInfoDetailList[i].other_master_list.length +
                this.claimInfoDetailList[i].other_list.length
            ) {
              this.other_all_num =
                this.claimInfoDetailList[i].other_master_list.length +
                this.claimInfoDetailList[i].other_list.length;
            }
            if (
              this.other_master_num <
              this.claimInfoDetailList[i].other_master_list.length
            ) {
              this.other_master_num =
                this.claimInfoDetailList[i].other_master_list.length;
            }
            if (
              this.other_num < this.claimInfoDetailList[i].other_list.length
            ) {
              this.other_num = this.claimInfoDetailList[i].other_list.length;
            }
          }
          this.meal_rowspan = Number(this.meal_num) + 1; //小計の分+1する
          this.vehicle_rowspan = Number(this.vehicle_num) + 1; //小計の分+1する
          this.other_rowspan = Number(this.other_all_num) + 1; //小計の分+1する

          // 食事リスト作り直し
          this.meal_list = [];
          for (let i = 0; i < this.meal_num; i++) {
            let meal_item = [];
            for (let j = 0; j < this.claimInfoDetailList.length; j++) {
              let item = [];

              if (this.claimInfoDetailList[j].meal_list.length > i) {
                item = this.claimInfoDetailList[j].meal_list[i];
              } else {
                item = {
                  class_name: "",
                  num: "",
                  fee: "",
                };
              }
              meal_item.push(item);
            }
            this.meal_list.push(meal_item);
          }

          // 車両リスト作り直し
          this.vehicle_list = [];
          for (let i = 0; i < this.vehicle_num; i++) {
            let vehicle_item = [];
            for (let j = 0; j < this.claimInfoDetailList.length; j++) {
              let item = [];

              if (this.claimInfoDetailList[j].vehicle_list.length > i) {
                item = this.claimInfoDetailList[j].vehicle_list[i];
              } else {
                item = {
                  class_name: "",
                  num: "",
                  fee: "",
                };
              }
              vehicle_item.push(item);
            }
            this.vehicle_list.push(vehicle_item);
          }

          // その他課金リスト作り直し
          this.other_master_list = [];
          // その他課金詳細（その他課金マスタにあるもの）
          for (let i = 0; i < this.other_master_num; i++) {
            let other_item = [];
            for (let j = 0; j < this.claimInfoDetailList.length; j++) {
              let item = [];

              if (this.claimInfoDetailList[j].other_master_list.length > i) {
                item = this.claimInfoDetailList[j].other_master_list[i];
              } else {
                item = {
                  class_name: "",
                  num: "",
                  fee: "",
                };
              }
              other_item.push(item);
            }
            this.other_master_list.push(other_item);
          }
          // その他課金詳細残り（その他課金マスタにないもの）
          this.other_list = [];
          for (let i = 0; i < this.other_num; i++) {
            let other_item = [];
            for (let j = 0; j < this.claimInfoDetailList.length; j++) {
              let item = [];

              if (this.claimInfoDetailList[j].other_list.length > i) {
                item = this.claimInfoDetailList[j].other_list[i];
              } else {
                item = {
                  class_name: "",
                  num: "",
                  fee: "",
                };
              }
              other_item.push(item);
            }
            this.other_list.push(other_item);
          }
        }
      });
      setTimeout(() => {}, 100);
    },
    //請求月のフィルタ
    dateFilter(value) {
      if (!this.dateFilterValue) {
        return true;
      }
      return value.includes(this.dateFilterValue);
    },
    //日付ダイアログのOK押下時にフィルタをセット（emmitで発火）
    setFilterValue() {
      this.dateFilterValue = this.selectDate.replace("-", "/");
    },
    //印刷
    printPage() {
      window.print();
    },
    //月次処理実績年月日表示
    getArchiveDataRange(value) {
      // 引数の年と月を整数に変換
      var year = parseInt(value.substr(0, 4));
      var month = parseInt(value.substr(5, 2));
      // 締め開始日
      var day = 1;

      var archiveYear = year;
      var archiveMonth = month - 1;
      if (archiveMonth == 0) {
        archiveYear = archiveYear - 1;
        archiveMonth = 12;
      }

      const firstDate = new Date(
        archiveYear,
        archiveMonth - 1,
        day
      ).toLocaleDateString();
      const lastDate = new Date(
        archiveYear,
        archiveMonth,
        day - 1
      ).toLocaleDateString();

      return firstDate + "～" + lastDate;
    },
    getUseFlg() {
      this.dmsUseFlg = this.$getDmsUseFlg(); //部屋利用フラグ
      this.carUseFlg = this.$getCarUseFlg(); //車両利用フラグ
      this.mealUseFlg = this.$getMealUseFlg(); //食事利用フラグ
      this.gasUseFlg = this.$getGasUseFlg(); //ガス利用フラグ
      this.elUseFlg = this.$getElUseFlg(); //電気利用フラグ
      this.waUseFlg = this.$getWaUseFlg(); //水道利用フラグ
      this.ocUseFlg = this.$getOcUseFlg(); //その他課金利用フラグ
      this.neiUseFlg = this.$getNeiUseFlg(); //自治会費利用フラグ
    },
  },
  updated() {
    this.getUseFlg();
  },
};
</script>

<style>
.row_style {
  border: 1px solid silver;
  padding-top: 5px;
  padding-bottom: 5px;
}

.row_style_top {
  border-top: 1px solid silver;
  border-right: 1px solid silver;
  border-left: 1px solid silver;
  padding-top: 5px;
  padding-bottom: 5px;
}

.row_style_bottom {
  border-bottom: 1px solid silver;
  border-right: 1px solid silver;
  border-left: 1px solid silver;
  padding-top: 5px;
  padding-bottom: 5px;
}

.row_style_center {
  border-right: 1px solid silver;
  border-left: 1px solid silver;
  padding-top: 5px;
  padding-bottom: 5px;
}

.RiyoushaBox {
  margin: 8px;
  border: 1px solid rgb(147, 179, 204);
}

.noBotPadding {
  padding-bottom: 0px;
}

.centar_content {
  text-align: center;
}
/*.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
          font-size: 12px !important
        }
        .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
          font-size: 12px !important
        }*/
.container {
  max-width: 3500px;
  max-height: 2000px;
}

.table_style {
  border-collapse: separate;
  //width: 40%;
  text-align: left;
}

.table_style td,
th {
  padding: 1px;
  font-size: 12px;
}

@media print {
  .no-print-area {
    display: none;
  }

  body {
    zoom: 0.3;
  }
}
</style>
